export default function(target) {
    Object.assign(target.prototype,{
        emit(eventName,...args){
            for(const child of this.children) {
                child[eventName] && child[eventName](...args);
                child.emit && child.emit(eventName,...args);
            }
        }
    });

    return target;
}